var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 43,
    viewBox: "0 0 50 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 25.632C40.069 34.973 31.719 42 21.711 42 10.272 42 1 32.822 1 21.5S10.272 1 21.711 1c9.986 0 18.323 6.997 20.276 16.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 21.5C35 28.955 28.955 35 21.5 35 14.044 35 8 28.955 8 21.5S14.044 8 21.5 8C28.955 8 35 14.045 35 21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 21a6 6 0 1 1-12 0 6 6 0 1 1 12 0zm-6 .5h25m.113-.5L49 17h-8.225C38.483 17.254 37 21 37 21m10.113 0L49 25h-8.225C38.483 24.747 37 21 37 21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpose);
export default __webpack_public_path__ + "static/media/purpose.5ea4b5f98da915320f97ecde5dee738d.svg";
export { ForwardRef as ReactComponent };